import React from 'react';
import { Paper, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const ContentSection = ({
  title,
  icon,
  content,
  titleColor = "#1b5e20",
  iconGradient = "linear-gradient(135deg, #43a047, #66bb6a)"
}) => {
  return (
    <Paper elevation={4} sx={{ p: 4, borderRadius: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Box sx={{
          background: iconGradient,
          color: 'white',
          p: 2,
          borderRadius: '50%',
          mr: 2
        }}>
          {icon}
        </Box>
        <Typography variant="h5" fontWeight={700} color={titleColor}>
          {title}
        </Typography>
      </Box>
      <List>
        {content.map((item, index) => (
          <ListItem key={index} sx={{ py: 1 }}>
            <ListItemText
              primary={
                <Typography variant="body1" sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
                  • {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ContentSection;
